export enum InvoiceStatus {
	Unpaid = 1,
	PartialPaid = 2,
	Paid = 3,
	Deleted = 4,
}

export enum InvoiceStatusDescription {
	Unpaid = 'Unpaid',
	PartialPaid = 'Partial Paid',
	Paid = 'Paid',
	Deleted = 'Deleted',
}
